/* eslint-disable */
import React, { useEffect, useState } from 'react';
import IconButton from './IconButton';
import { RxCross2 } from 'react-icons/rx'

const ConfirmationModal = ({ modalData }) => {
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        setShowModal(true);
    }, [])
    return (
        <div className={`text-white fixed inset-0 !mt-0 z-[100] flex justify-center items-center bg-white bg-opacity-10 backdrop-blur-sm`}>
            <div className={`${showModal ? 'scale-100' : 'scale-0'} w-11/12 max-w-[25rem] rounded-lg border border-richblack-400 bg-richblack-800 p-6 relative transition-transform duration-300 origin-center`}>
                {modalData?.text1 &&
                    <p className='text-2xl font-semibold text-richblack-5'>
                        {modalData?.text1}
                    </p>
                }
                {modalData?.text2 &&
                    <p className='mt-3 mb-5 leading-6 text-richblack-200'>
                        {modalData.text2}
                    </p>
                }
                <div className='flex items-center gap-x-4'>
                    {modalData?.btn1Handler && modalData?.btn1Text &&
                        <IconButton
                            onClick={modalData?.btn1Handler}
                            text={modalData?.btn1Text}
                            customClasses={'bg-yellow-50 cursor-pointer rounded-md py-2 px-5 font-semibold text-richblack-900'}
                        />
                    }
                    {modalData?.btn2Handler && modalData?.btn2Text &&
                        <button
                            className='rounded-md bg-richblack-200 cursor-pointer py-[8px] px-[20px] font-semibold text-richblack-900'
                            onClick={modalData?.btn2Handler}
                        >
                            {modalData?.btn2Text}
                        </button>
                    }
                </div>
                {modalData?.closeModal &&
                    <button
                        className='text-2xl text-richblack-5 absolute top-2 right-2'
                        onClick={modalData?.closeModal}
                    >
                        <RxCross2 />
                    </button>}
            </div>
        </div>
    );
};

export default ConfirmationModal;